var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60452C",
    d: "M10.133 5.867H5.867v4.266h4.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60452C",
    d: "M0 0v14.75l2.828-2.829V2.828h9.094L14.75 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81663C",
    d: "M16 16V1.25L13.172 4.08v9.093H4.078L1.25 16z"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/roles/alt-2/bot-off.svg";
export { SvgBotOff as ReactComponent };